import React from "react";
import { Link } from "react-router-dom";
import { Archive, Radar } from "lucide-react";
import WebControlRoom from "./WebFounderDashboard";

/**
 * /admin — Web Control Room (default founder dashboard).
 * All WhatsApp-era panels live at /admin/legacy and are unmodified.
 */
export default function Admin() {
  return (
    <div className="min-h-screen bg-[#0a0a0a] text-neutral-100 font-sans">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 sm:py-16">
        <div className="flex items-start justify-between mb-10 gap-4 flex-wrap">
          <div>
            <p className="label-eyebrow mb-2">admin · web</p>
            <h1 className="font-display font-light text-3xl sm:text-4xl tracking-tight">
              Web Control Room
            </h1>
            <p className="text-sm text-neutral-500 mt-2 max-w-xl leading-relaxed">
              The current web product. Web-only metrics, smoke-filtered, founder-grade.
              WhatsApp-era panels live in the legacy archive.
            </p>
          </div>
          <div className="flex items-center gap-2 flex-wrap">
            <Link
              to="/admin/command"
              className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-emerald-800/60 bg-emerald-950/40 text-emerald-100 hover:bg-emerald-950/60 text-xs font-medium"
              data-testid="admin-command-center-link"
            >
              <Radar size={14} />
              Command Center
            </Link>
            <Link
              to="/admin/founder-intel"
              className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-emerald-900/40 bg-emerald-950/20 text-emerald-200 hover:bg-emerald-950/40 text-xs"
              data-testid="admin-founder-intel-link"
            >
              <Radar size={14} />
              Founder Intelligence
            </Link>
            <Link
              to="/admin/legacy"
              className="inline-flex items-center gap-2 px-3 py-2 rounded-lg border border-amber-900/40 bg-amber-950/20 text-amber-200 hover:bg-amber-950/40 text-xs"
              data-testid="admin-legacy-link"
            >
              <Archive size={14} />
              WhatsApp Legacy Archive
            </Link>
          </div>
        </div>

        <WebControlRoom />
      </div>
    </div>
  );
}
